'use client';

import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '@/lib/api/client';

// The default company's name and website domain.
export function useDefaultBrand(enabled = true) {
  return useQuery({
    queryKey: ['brand'],
    queryFn: () => fetchJson<{ ok: true; name: string; domain: string | null }>('/api/brand'),
    enabled,
    staleTime: Infinity,
  });
}

// The name a customer page shows: the company in context when the page has
// one, otherwise the default company (fetched only then).
export function useBrandName(contextName: string | undefined): string {
  const query = useDefaultBrand(contextName === undefined);
  return contextName ?? query.data?.name ?? '';
}

// Customer pages ship a neutral static title (the root layout's is the staff
// CRM's); the brand is appended once it is known.
export function useBrandTitle(title: string, brandName: string): void {
  useEffect(() => {
    if (brandName) {
      document.title = `${title} — ${brandName}`;
    }
  }, [title, brandName]);
}
